import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ClothingOption, ClothingUserOption } from '../../../models/clothing.model';

interface ClothingSettingsField {
  key: string;
  labelKey: string;
  type: string;
  min?: number;
}

interface ClothingSettingsFormModel {
  storekeeperUserId: string;
  ceoUserId: string;
  officeDepartmentMarkerCode: string;
  summerStartMonthDay: string;
  summerEndMonthDay: string;
  outOfStockExtensionMonths: number;
  refusalThreshold: number;
  refusalWindowMonths: number;
  headOverdueAfterExpiryDays: number;
  active: boolean;
}

@Component({
  selector: 'app-clothing-admin-settings-form',
  templateUrl: './clothing-admin-settings-form.component.html',
  styleUrls: ['./clothing-admin-settings-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingAdminSettingsFormComponent {
  @Input() hideHeader = false;
  @Input() settings: ClothingSettingsFormModel;
  @Input() storekeeperOptions: ClothingUserOption[] = [];
  @Input() ceoOptions: ClothingUserOption[] = [];
  @Input() officeMarkerOptions: ClothingOption[] = [];
  @Input() isSaving = false;
  @Output() saveSettings = new EventEmitter<void>();

  numericFields: ClothingSettingsField[] = [
    { key: 'outOfStockExtensionMonths', labelKey: 'CLOTHING_SETTINGS_OUT_OF_STOCK_MONTHS', type: 'number', min: 0 },
    { key: 'refusalThreshold', labelKey: 'CLOTHING_SETTINGS_REFUSAL_THRESHOLD', type: 'number', min: 0 },
    { key: 'refusalWindowMonths', labelKey: 'CLOTHING_SETTINGS_REFUSAL_WINDOW_MONTHS', type: 'number', min: 0 },
    { key: 'headOverdueAfterExpiryDays', labelKey: 'CLOTHING_SETTINGS_HEAD_OVERDUE_DAYS', type: 'number', min: 0 }
  ];
  monthDayFields: ClothingSettingsField[] = [
    { key: 'summerStartMonthDay', labelKey: 'CLOTHING_SETTINGS_SUMMER_START', type: 'text' },
    { key: 'summerEndMonthDay', labelKey: 'CLOTHING_SETTINGS_SUMMER_END', type: 'text' }
  ];

  submit() {
    this.saveSettings.emit();
  }

  trackByUser(index: number, user: ClothingUserOption): string {
    return user.id;
  }

  trackByOption(index: number, option: ClothingOption): string {
    return option.id;
  }

  trackByField(index: number, field: ClothingSettingsField): string {
    return field.key;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-settings-form.component.ts